import React from 'react';
import Body from '../components/Body';
import TripDetail from '../components/travel/TripDetail';

export default function TripDetailPage() {
    return (
        <Body sidebar>
            <TripDetail />
        </Body>
    );
}
